import React from 'react'
import { PropTypes } from 'prop-types'
import { useIntl } from 'react-intl'

import {
  IconLink1,
  IconFAImage,
  Flex,
  Title,
  TITLE_VARIANT_M
} from 'mailup-web-components'
import TableLinks from './components/TableLinks'
import { IconWrapper } from '../commonComponents/commonComponents'

const LinkSection = ({ sectionType }) => {
  const intl = useIntl()

  return (
    <>
      <Flex margin='8px 0' columnGap='16px'>
        <IconWrapper fontSize='18px' color='var(--mine-shaft)'>
          {sectionType === 'link' ? <IconLink1 /> : <IconFAImage />}
        </IconWrapper>
        <Title variant={TITLE_VARIANT_M}>
          {sectionType === 'image'
            ? intl.formatMessage({
                id: 'Load.EmailCheckUp.LinkCheckImagesHeader'
              })
            : intl.formatMessage({
                id: 'Load.EmailCheckUp.LinkCheckLinkHeader'
              })}
        </Title>
      </Flex>
      <TableLinks linkType={sectionType} />
    </>
  )
}

LinkSection.propTypes = {
  sectionType: PropTypes.string
}

export default LinkSection
